export function setLoggedInUser(state, payload) {
  state.loggedInUser = payload;
  state.hasUserLoggedIn = !!payload;
}
export function setUsers(state, payload) {
  state.users = payload;
}
